import React, { useState, useEffect } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import { useAuth } from '../context/AuthContext'; // Import authentication context
import '../styles/TailNumberDropdown.scss';
import { ILogTContent } from '../models/logTContent';
import { fetchAirlineByAirline } from '../services/logTContentService';

interface TailNumberDropdownProps {
  value: string;
  onChange: (newValue: string) => void;
  airline: string; // Airline selected by the user
  canSelectAS: boolean; // Whether the user has access to Alaska Airlines
  canSelectQX: boolean; // Whether the user has access to Horizon Airlines
  flag: string; // Whether the user has access to Horizon Airlines
}

const TailNumberDropdown: React.FC<TailNumberDropdownProps> = ({ value, onChange, airline, canSelectAS, canSelectQX,flag }) => {
  const [options, setOptions] = useState<string[]>([]);
  const { userData } = useAuth(); // Get user data 
  const [isLoading, setIsLoading] = useState(false);
  const userGroups = useAuth();
  const accessToken = userGroups?.userData?.access_token || ''; 
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchAirlineByAirline(airline, accessToken);  
        setOptions(response);
      } catch (error) {
        console.error('Error fetching tail numbers: ', error);
      }
    };

    fetchData();
  }, [airline]);
 
  
  return (
    <div className="tailnumber-dropdown">
      <Autocomplete
        disablePortal
        options={options} // Use the filtered tail numbers
        value={value}
        onChange={(event, newValue) => {
          onChange(newValue || '');
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Search by AC Reg #"
            variant="outlined"
            sx={{
              '& .MuiOutlinedInput-root': {
                color: 'white',
                backgroundColor: 'var(--ds-color-background-darkest)',
                '& fieldset': { display: 'none !important' },
                '&:hover fieldset': { display: 'none !important' },
                '&.Mui-focused fieldset': { display: 'none !important' },
              },
              '& .MuiInputBase-root': {
                '& fieldset': { display: 'none !important' },
              },
              '& .MuiSvgIcon-root': { color: 'white' },
            }}
          />
        )}
        sx={{
          '& .MuiAutocomplete-popupIndicator': { color: 'white' },
          '& .MuiAutocomplete-clearIndicator': { color: 'white' },
          '& .MuiAutocomplete-listbox': {
            backgroundColor: 'var(--ds-color-background-darkest)',
            color: 'white',
            '& .MuiAutocomplete-option': {
              '&[aria-selected="true"]': { backgroundColor: 'var(--ds-color-background-light)' },
              '&:hover': { backgroundColor: 'var(--ds-color-background-light)' },
            },
          },
          '& .MuiAutocomplete-popper': {
            backgroundColor: 'var(--ds-color-background-darkest)',
            color: 'white',
            marginTop: '0px',
            borderRadius: '4px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          },
        }}
      />
    </div>
  );
};

export default TailNumberDropdown;
